import styled from 'styled-components';

export const ContentContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;

  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

export const ChallengeLabel = styled.span`
  color: ${({ theme }) => theme.communityList.selectedColor};
  font-weight: 500;
  font-size: 1.5rem;
  text-align: center;
  margin: auto;
  margin-bottom: 10px;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: flex-start;
`;

export const RankingExplanationText = styled.span`
  color: ${({ theme }) => theme.info};
  text-align: center;
  font-size: 1.125rem;
  margin-bottom: 10px;
`;

export const RankListContainer = styled.div`
  width: 100%;
`;
